import React from "react";
import { motion } from "framer-motion";
import { BrandHeader } from "./BrandHeader";
import { StatusPill } from "./StatusPill";

export const InvoiceHeader = ({ creator, invoice, theme, themeName, brand }) => (
  <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
    <div className={theme.labelCls}>Quill Invoice</div>
    <div
      className={`mt-4 flex ${theme.centeredHead ? "flex-col items-center text-center gap-4" : "items-start justify-between"} gap-6`}
    >
      <BrandHeader creator={creator} theme={theme} themeName={themeName} />
      <div className={theme.centeredHead ? "" : "text-right"}>
        <div className={`${theme.sectionLabel} mb-1`} style={theme.bgAccent ? { color: brand } : undefined}>
          Invoice
        </div>
        <div
          className={`${theme.headingFont} ${theme.numberCls}`}
          style={themeName === "manuscript" ? { color: brand } : undefined}
          data-testid="invoice-number"
        >
          {invoice.number}
        </div>
        <div className="mt-3 inline-block">
          <StatusPill status={invoice.status} theme={theme} />
        </div>
      </div>
    </div>
    {/* Accent rule for atelier (double rule under header) */}
    {themeName === "atelier" && (
      <div className="mt-6 border-double border-b-[3px]" style={{ borderColor: brand }} />
    )}
    {/* Manuscript ornament */}
    {theme.ornament && (
      <div className="mt-6 relative" data-testid="manuscript-ornament">
        <div className={`border-t ${theme.rule}`} />
        <div
          className="absolute left-1/2 -translate-x-1/2 -top-3 px-3 text-lg"
          style={{ background: "#FBF7EC", color: brand }}
        >
          ❦
        </div>
      </div>
    )}
  </motion.div>
);
